import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Grid from '../../../Grid';
import s from './TierGrid.scss';
export class TierGrid extends React.Component {
    render() {
        const { tiers, cookieType, isTierPromotion, isMobile } = this.props;
        if (!tiers) {
            return null;
        }
        const breakpoints = isTierPromotion ? [
            {
                maxWidth: 9999,
                elementWidth: 270,
                elementHeight: 147
            }
        ] : [
            {
                maxWidth: 9999,
                elementWidth: 360,
                elementHeight: 330
            }
        ];
        return /*#__PURE__*/ React.createElement(Grid, {
            className: s['root'],
            breakpoints: breakpoints,
            cookieType: cookieType,
            elementCount: tiers.length,
            getElementId: this.getTierId,
            renderElement: this.renderTier,
            spacing: isMobile ? 10 : 16,
            enableScrollOptim: false
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getTierId", (index)=>{
            const { tiers = [] } = this.props;
            const item = tiers[index];
            return item.deviationId;
        });
        _define_property(this, "renderTier", ({ style, width, index })=>{
            const { tierRenderer } = this.props;
            return /*#__PURE__*/ React.createElement("div", {
                style: style
            }, tierRenderer({
                index,
                width
            }));
        });
    }
}
export default withMobileContext(TierGrid);

//# sourceMappingURL=TierGrid.js.map